import { useTranslation } from 'react-i18next';

import { GroupSubscriptionsElement } from '@shared/dream-components';

import { useGroupSubscriptionsContext } from '~/context/SubscriptionManagement';

import { GroupSubscriptionCardContainer } from './GroupSubscriptionCardContainer';

/**
 * Renders the Groups tab — the group-subscriptions list, its per-group cards, and the modal
 * layer. Data, handlers, translations, and modal coordination all come from
 * `GroupSubscriptionsProvider` via context. Pure UI, no props, no data logic.
 */
export const GroupSubscriptionsSection = () => {
  const { t } = useTranslation();
  const {
    groupSubscriptions,
    isLoadingGroupSubscriptions,
    groupSubscriptionsMutationVersion,
    translations,
    groupBillingPortalAction,
    modals,
    onRetryFailedPayment,
    onRestoreSubscription,
    onViewBilling,
  } = useGroupSubscriptionsContext();

  return (
    <div className="flex w-full flex-col gap-4">
      {isLoadingGroupSubscriptions ? (
        <div className="flex flex-col w-full gap-4">
          <p className="text-sm text-gray-500">{t('manage.groups.loading')}</p>
        </div>
      ) : (
        <GroupSubscriptionsElement
          element={{
            type: 'groupSubscriptions',
            attrs: {
              data: { groups: groupSubscriptions },
            },
          }}
          isLive
          translations={translations}
          renderCard={(group, { isExpanded, onToggleExpanded }) => (
            <GroupSubscriptionCardContainer
              group={group}
              isExpanded={isExpanded}
              onToggleExpanded={onToggleExpanded}
              mutationVersion={groupSubscriptionsMutationVersion}
              translations={translations}
              onOpenManageSeats={() => modals.openManageSeats(group.id)}
              onOpenInviteByEmail={() => modals.openInviteByEmail(group.id)}
              onOpenBulkInviteCsv={() => modals.openBulkInviteCsv(group.id)}
              onOpenConfirm={(kind, seatIds, firstEmail) => modals.openConfirm(group.id, kind, seatIds, firstEmail)}
              onOpenModifyReduction={() => modals.openModifyReduction(group.id)}
              onOpenCancelReduction={() => modals.openCancelReduction(group.id)}
              onRetryFailedPayment={() => onRetryFailedPayment(group.id)}
              onCancelSubscription={() => modals.openCancelSubscription(group.id)}
              onRestoreSubscription={() => onRestoreSubscription(group.id)}
              updatePaymentMethodAction={groupBillingPortalAction}
              onViewBilling={onViewBilling}
            />
          )}
        >
          {null}
        </GroupSubscriptionsElement>
      )}
      {modals.modals}
    </div>
  );
};
